import React from "react";
import HumanBanner from "../humanresources/HumanBanner";
import HomeClientLogo from "../../home/HomeClientLogo";
import HumanPotential from "../humanresources/HumanPotential";
import HomeCounter from "../../home/HomeCounter"
import HumanDiscuss from "../humanresources/HumanDiscuss";
import HumanBenefits from "../humanresources/HumanBenefits";
import HumanGoals from "../humanresources/HumanGoals";
import HumanCompany from "../humanresources/HumanCompany";
import HumanSmart from "../humanresources/HumanSmart";
import SalesEcosystem from "./SalesEcosystem";

const bannerData = {
  head: "Accelerate Sales Performance with Smarter Document Management",
  desc: "In sales, speed, accuracy, access to the right information can make or break a deal. Dox and Box empowers sales teams to close faster by centralizing documents, automating approvals, streamlining every stage, from quote to contract. With better visibility and seamless collaboration, your team can focus on what truly matters: driving revenue.",
  slug: "",
  btn: "Contact Us",
  img: "/assets/images/sales-banner-image.webp"
}

const humanPotentialData = {
  head: "Turn Sales Challenges into Growth Opportunities",
  boxes: [
    {
      title: "Common Challenges in Sales Operations",
      list: [
        {
          label: "Manual Work Slows Sales Teams",
          desc: "Sales reps spend valuable time managing documents and chasing information instead of focusing on closing deals."
        },
        {
          label: "Disorganized Data Delays Decisions",
          desc: "Scattered files, outdated versions, missing documents lead to slower responses and lost opportunities."
        },
        {
          label: "Disconnected Teams Impact Performance",
          desc: "Lack of coordination between sales, marketing, customer service creates inefficiencies and breaks the customer journey."
        },
        {
          label: "Compliance & Data Risks",
          desc: "Inconsistent handling of contracts and customer data increases exposure to compliance and legal risks."
        },
      ]
    },
    {
      title: "Work Smarter with Dox and Box",
      list: [
        {
          label: "More Selling, Less Administration",
          desc: "Automate repetitive tasks and free up your team to focus on revenue-generating activities."
        },
        {
          label: "Centralized Access & Full Visibility",
          desc: "Access all sales documents instantly from one secure platform, anytime, anywhere."
        },
        {
          label: "Improved Team Alignment",
          desc: "Enable seamless collaboration across teams with structured workflows and shared access to information."
        },
        {
          label: "Secure & Compliant Processes",
          desc: "Ensure controlled access, secure document handling, compliance with data protection standards."
        },
      ]
    }
  ]
}

const countData = [
  {
    number: "24",
    suffix: "K+",
    desc: "<b>Businesses Served</b>: Trusted by organizations across diverse industries"
  },
  {
    number: "99",
    suffix: "%",
    desc: "<b>Retrieval Accuracy</b>: Ensure fast, precise, reliable access to documents"
  },
  {
    number: "14",
    suffix: "K+",
    desc: "<b>Documents Digitized</b>: Converted into structured, indexed, fully searchable digital formats"
  },
  {
    number: "40",
    suffix: "%",
    desc: "<b>Efficiency Gains</b>: Reduce manual effort, streamline workflows, & operational productivity"
  },
]

const discussData = {
  head: "Smarter HR workflows start here",
  desc: "Give our specialists a call on",
  number: "+91 9580374374",
  btn: "Contact Us",
  slug: "/contact",
  newClass: "sales-discuss-area"
}

const smartData = {
  head: "Transform Your Sales Workflows and Deal Management",
  desc: "Streamline every stage of your sales cycle, from lead to contract, with secure, digital processes that enhance speed, visibility, control.",
  boxes: [
    {
      label: "Digital Customer Files",
      innerHead: "Instant access to all customer and sales documents",
      innerDesc: "From quotes and proposals to orders, invoices, communications, everything your sales team needs is centralized and easy to find. Dox and Box ensures all customer-related documents are securely stored, searchable, accessible, enabling faster responses and consistent customer engagement.",
      btn: "Contact Us",
      slug: "/contact",
      image: "/assets/images/sales-transform-img-1.webp"
    },
    {
      label: "Sales Order Processing",
      innerHead: "Smarter workflows for faster order execution",
      innerDesc: "Streamline order management from initial inquiry to final invoicing. Automated workflows route approvals, such as pricing or discount validations, to the right stakeholders, reducing delays and improving turnaround time.",
      btn: "Contact Us",
      slug: "/contact",
      image: "/assets/images/sales-transform-img-2.webp"
    },
    {
      label: "Contract Management",
      innerHead: "Stay in control of every deal",
      innerDesc: "Manage contracts with complete visibility over versions, approvals, timelines. Ensure teams always access the latest version while automating approval workflows to avoid delays and errors.",
      btn: "Contact Us",
      slug: "/contact",
      image: "/assets/images/sales-transform-img-3.webp"
    },
    {
      label: "Electronic Signatures",
      innerHead: "Faster, seamless deal closures",
      innerDesc: "Integrate e-signatures directly into your sales workflows to accelerate contract approvals. Eliminate manual steps and enable secure, anytime signing, helping you close deals faster across locations.",
      btn: "Contact Us",
      slug: "/contact",
      image: "/assets/images/sales-transform-img-4.webp"
    },
    {
      label: "Secure Archiving",
      innerHead: "Protect data and build trust",
      innerDesc: "Store and manage customer documents securely with compliance-ready archiving. Automated retention policies, access controls, audit trails ensure your data is always protected and easily accessible.",
      btn: "Contact Us",
      slug: "/contact",
      image: "/assets/images/sales-transform-img-5.webp"
    },

  ],
}

const benifitData = {
  head: "Driving Digital Transformation Across Your Sales Ecosystem",
  boxClass: "",
  slides: [
    {
      label: "Faster Deal Cycles",
      desc: "Accelerate approvals and contract processes to close deals quicker.",
      img: '/assets/images/sales-efficient-icon-1.webp'
    },
    {
      label: "Streamlined Document Management",
      desc: "Organize quotes, proposals, contracts in one centralized system.",
      img: '/assets/images/sales-efficient-icon-2.webp'
    },
    {
      label: "Enhanced Collaboration",
      desc: "Connect sales, marketing, support teams for a unified customer experience.",
      img: '/assets/images/sales-efficient-icon-3.webp'
    },
    {
      label: "Better Sales Insights",
      desc: "Gain visibility into document workflows and performance to make informed decisions.",
      img: '/assets/images/sales-efficient-icon-2.webp'
    },
  ]
}

const goalData = {
  head: "Why Sales Teams Choose Dox and Box?",
  boxes: [
    {
      img: "/assets/images/human-goal-icon1.webp",
      title: "Intelligent Data Capture",
      desc: "Automatically extract and organize key information from sales documents to reduce manual effort.",
      slug: "",
    },
    {
      img: "/assets/images/human-goal-icon2.webp",
      title: "Workflow Automation",
      desc: "Accelerate approvals and eliminate bottlenecks with structured, automated processes.",
      slug: "",
    },
    {
      img: "/assets/images/human-goal-icon3.webp",
      title: "Document Hub",
      desc: "Access all sales-related documents in one secure, searchable platform with easy team collaboration and sharing",
      slug: "",
    },
    {
      img: "/assets/images/human-goal-icon4.webp",
      title: "Seamless Collaboration",
      desc: "Enable real-time coordination across sales, finance, operations teams.",
      slug: "",
    },
    {
      img: "/assets/images/human-goal-icon5.webp",
      title: "Actionable Insights",
      desc: "Gain visibility into sales processes and performance for better decision-making.",
      slug: "",
    },
    {
      img: "/assets/images/human-goal-icon6.webp",
      title: "Security & Compliance",
      desc: "Ensure safe handling of data with role-based access and compliance systems.",
      slug: "",
    },
  ]
}

export default function Sales() {
  return (
    <>
      <HumanBanner data={bannerData} />
      <HomeClientLogo />
      <HumanPotential data={humanPotentialData} />
      <HomeCounter countData={countData} />
      <HumanDiscuss data={discussData} />
      <HumanBenefits data={benifitData} />
      <HumanSmart smartData={smartData} />
      <SalesEcosystem />
      <HumanGoals data={goalData} />
      <HumanCompany />
    </>
  )
}